import axios from 'axios';

const apiClient = axios.create({
  baseURL: 'https://realhealthcareayurveda.cinecreativemedia.com',
  headers: { 'Content-Type': 'application/json' },
});

apiClient.interceptors.request.use((config) => {
  const token = localStorage.getItem('admin_token');
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  if (config.data instanceof FormData) {
    delete config.headers['Content-Type'];
  }
  return config;
});

apiClient.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      localStorage.removeItem('admin_token');
      localStorage.removeItem('admin_role');
      localStorage.removeItem('admin_email');
      if (window.location.pathname !== '/login') {
        window.location.href = '/login';
      }
    }
    return Promise.reject(error);
  }
);

export default apiClient;

export function getErrorMessage(error) {
  const data = error.response?.data;
  if (data?.errors?.length) {
    return data.errors.map((e) => e.msg || e.message).join(', ');
  }
  return data?.message || error.message || 'Something went wrong';
}
